import { useEffect, useRef } from 'react';
import { analytics } from '@shared/posthog';
import type { CheckoutPlanType } from '../lib/checkout-plan-content';

export function useTrackAdvisorCheckoutViewed(
  advisorId: string | undefined,
  planType: CheckoutPlanType,
  enabled = true,
) {
  const capturedCheckoutKeyRef = useRef<string | null>(null);

  useEffect(() => {
    if (!enabled) {
      capturedCheckoutKeyRef.current = null;
      return;
    }
    if (!advisorId) return;

    const checkoutKey = `${advisorId}:${planType}`;
    if (capturedCheckoutKeyRef.current === checkoutKey) return;

    capturedCheckoutKeyRef.current = checkoutKey;
    analytics.advisor.checkoutViewed({ advisorId, planType });
  }, [advisorId, enabled, planType]);
}
